module.exports = __webpack_public_path__ + "assets/footer_logo.6f671833.svg";